module.exports = __webpack_public_path__ + "static/media/parental-family.a35f59f5.svg";